import axios from 'axios';

// Usar variable de entorno o URL de producción por defecto
const API_URL = process.env.REACT_APP_API_URL || 'https://fotos-backend.agreeabledesert-5b0f733a.eastus.azurecontainerapps.io/api';

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true  // Necesario para CORS con credenciales
});

// Interceptor para agregar el token a cada petición
api.interceptors.request.use(
  (config) => {
    // No agregar token a las rutas de autenticación
    const isAuthRoute = config.url.includes('/auth/login') || config.url.includes('/auth/registro') || config.url.includes('/auth/google');
    
    if (!isAuthRoute) {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthRoute = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/auth/registro') || error.config?.url?.includes('/auth/google');

    // No forzar redirección/limpieza de sesión por un 401 de un intento de login fallido:
    // esos 401 son respuestas esperadas (credenciales/token de Google inválidos) que la
    // página de login debe mostrar, no un evento de "sesión expirada".
    if (error.response && error.response.status === 401 && !isAuthRoute) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
